export const CustomFieldsApi = Symbol.for('CustomFieldsApi');
